var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.672 8.83931H30.9376V5.52457C30.9376 2.47722 28.4581 0 25.413 0H18.7835C15.7384 0 13.259 2.47722 13.259 5.52457V8.83931H5.52457C2.47943 8.83931 0 11.3165 0 14.3639V24.3081H13.3717C13.8843 21.7889 16.1163 19.8884 18.7835 19.8884H25.413C28.0803 19.8884 30.3122 21.7889 30.8249 24.3081H44.1965V14.3639C44.1965 11.3165 41.7171 8.83931 38.672 8.83931ZM28.7277 8.83931H15.4688V5.52457C15.4688 3.69704 16.956 2.20983 18.7835 2.20983H25.413C27.2405 2.20983 28.7277 3.69704 28.7277 5.52457V8.83931ZM25.413 30.9383H18.7835C16.1163 30.9383 13.8843 29.0379 13.3717 26.5187H0V38.6727C0 41.7201 2.47943 44.1973 5.52457 44.1973H38.672C41.7171 44.1973 44.1965 41.7201 44.1965 38.6727V26.5187H30.8249C30.3122 29.0379 28.0803 30.9383 25.413 30.9383ZM28.727 25.4097C28.727 27.2372 27.2398 28.7245 25.4123 28.7245H18.7828C16.9553 28.7245 15.4681 27.2372 15.4681 25.4097C15.4681 23.5822 16.9553 22.095 18.7828 22.095H25.4123C27.2398 22.095 28.727 23.5822 28.727 25.4097Z",
    fill: "url(#paint0_linear_1013_844)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1013_844",
    x1: 68.948,
    y1: 7.09828,
    x2: 61.6338,
    y2: 55.7764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseColored);
export default __webpack_public_path__ + "static/media/briefcase-colored.1d6c0152796b5bb312372d3c602a3945.svg";
export { ForwardRef as ReactComponent };